var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../../AppState';
const getPromoData = (promoId) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { onePlatformApiRoot, targetedPromotion, onePlatformApiClientId, onePlatformApiClientSecret, token } = settings;
    return fetch(`${onePlatformApiRoot}${targetedPromotion}/${promoId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'client_secret': `${onePlatformApiClientSecret}`,
            'client_id': `${onePlatformApiClientId}`
        }
    }).then((response) => __awaiter(void 0, void 0, void 0, function* () {
        if (!response.ok) {
            return false;
        }
        else {
            return yield response.json();
        }
    }));
});
const onePlatformCheckPromoValidity = (promoId) => __awaiter(void 0, void 0, void 0, function* () {
    const promoData = yield getPromoData(promoId);
    if (promoData) {
        const { validFor } = promoData;
        const { endDateTime } = validFor;
        const promoExpiryDate = new Date(endDateTime);
        if (promoExpiryDate > new Date()) {
            return promoData;
        }
    }
    return false;
});
export default onePlatformCheckPromoValidity;
